import { makeStyles } from '@material-ui/core';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      margin: theme.spacing(3, 2, 0.75),
    },
    spacer: {
      flex: '1',
      borderBottom: `2px solid ${COLORS.neutral.darkGray}`,
      margin: theme.spacing(1.5, 0),
    },
    item: {},
    menu_paper: {
      width: 248,
      marginTop: theme.spacing(0.75),
      border: 'none',
    },
    createProjectButton: {
      backgroundColor: COLORS.primary.active,
      color: COLORS.neutral.white,
      width: '100%',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),

      '&:hover': {
        backgroundColor: COLORS.primary.active,
      },

      '& > span': {
        paddingRight: theme.spacing(1.5),
      },
    },
    createProjectButtonStartIcon: {
      fontSize: theme.typography.pxToRem(14),
      marginRight: theme.spacing(0.75),
    },
    menuItemsWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    submenu: {},
    menuItem: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    divider: {
      marginBottom: theme.spacing(2),
      display: 'none',
    },
  }),
  { name: 'SidebarItems' }
);
